module.exports = __webpack_public_path__ + "img/sum.790b02c1.png";